export const legalUnits = [
    {
        key: "item",
        name: "",
        pluralName: "",
    },
    {
        key: "bucket",
        name: "bucket",
        pluralName: "buckets",
    },
    {
        key: "bunch",
        name: "bunch",
        pluralName: "bunches",
        minorUnitName: "stem",
        minotUnitPluralName: "stems",
    },
    {
        key: "stem",
        name: "stem",
        pluralName: "stems",
    },
    {
        key: "bouquet",
        name: "bouquet",
        pluralName: "bouquets",
    },
    {
        key: "csa",
        name: "",
        minorUnitName: "week",
        minotUnitPluralName: "weeks",
        pluralName: "",
    },
];
//# sourceMappingURL=units.js.map